import { defineMessages } from 'react-intl';

export const stories = [
  {
    type: 'story',
    name: 'Platform for everyone',
    messages: defineMessages({
      title: {
        id: 'company.page.stories.title.first',
        defaultMessage: 'Indorse',
      },
      subtitle: {
        id: 'company.page.stories.subtitle.first',
        defaultMessage: 'Brand Values',
      },
      description: {
        id: 'company.page.features.description.first',
        defaultMessage:
          'At Indorse, we believe in the power of the people. With simple and objective skill validation, we empower everyone to show and validate their skills, put them to use and reach their full potential. The assessment of skills is powered by human expertise through our community of expert developers. Lastly, we hand over control of the whole platform to our users by letting them participate in the success through the IND token economy.',
      },
    }),
    img: require('./img/brand-story-women.png'),
  },
  {
    type: 'story',
    name: 'Growth',
    messages: defineMessages({
      title: {
        id: 'company.page.stories.title.second',
        defaultMessage: 'Indorse',
      },
      subtitle: {
        id: 'company.page.stories.subtitle.second',
        defaultMessage: 'Visual Identity',
      },
      description: {
        id: 'company.page.features.description.second',
        defaultMessage:
          'Because Indorse is easy to use, its visual identity is simple. The design is based on the three basic shapes: The square symbolizes blockchain. The ascending triangle stands for improving skills, and the circle represents the people in a community. These elements are featured throughout the platform and communication, from the logo and corporate design to the user interface with the unique visual skill pattern on each profile page.',
      },
    }),
    caption: 'Culinary: Mick Elysee',
    img: 'isSvg',
  },
];

export const highlightElements = [
  {
    type: 'highlightElement',
    messages: defineMessages({
      title: {
        id: 'company.page.stories.highlightElement.first',
        defaultMessage: 'ELEMENT 1',
      },
    }),
  },
  {
    type: 'highlightElement',
    messages: defineMessages({
      title: {
        id: 'company.page.stories.highlightElement.second',
        defaultMessage: 'ELEMENT 2',
      },
    }),
  },
  {
    type: 'highlightElement',
    messages: defineMessages({
      title: {
        id: 'company.page.stories.highlightElement.third',
        defaultMessage: 'ELEMENT 3',
      },
    }),
  },
  {
    type: 'highlightElement',
    messages: defineMessages({
      title: {
        id: 'company.page.stories.highlightElement.fourth',
        defaultMessage: 'ELEMENT 4',
      },
    }),
  },
];



// WEBPACK FOOTER //
// ./src/resources/page/company/brand-stories/index.js